// import { IoSearch } from "react-icons/io5";
import './style.css'

export interface ISearchBarProps {
  actions?: React.ReactNode
}

export function SearchBar(props: ISearchBarProps) {
  const {actions} = props

  return (
    <div className='search-bar'>
      <div className='query'>
        {/* <IoSearch className='icon' /> */}
        <div className='search-input'></div>
        <div className='actions'>{actions}</div>
      </div>
      <div
        className='results'
        style={{
          display: 'none',
        }}
      >
        results
      </div>
    </div>
  )
}
